import React, { useEffect, useState, useMemo } from "react";
import CountUp from "react-countup";
import axios from "axios";
import { Link, NavLink, useOutletContext, useParams } from "react-router-dom";
import { currency_converter_inr } from "../../../utils/currencyUtils";
import { MaterialReactTable } from "material-react-table";
import { decodeHtml } from "../../../utils/decodeHtml";
import { openInAppTab } from "../../../utils/tabNavigation";
import { colors } from "@mui/material";

function InvoicePipeline() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const PINE_BASE_URL = process.env.REACT_APP_PINE_BASE_URL;
  const [data, setData] = useState([]);
  const [options, setOptions] = useState([]);
  const {setGlobalLoading, token } = useOutletContext();
  const [selectedManager, setSelectedManager] = useState("");
  
  const formatNumber = (num) => {
    if (!num) return 0;
    return new Intl.NumberFormat("en-IN").format(num);
    };
  async function fetchOptions() {
    setGlobalLoading(true);
    try {
        const response = await axios.get(
        `${API_BASE_URL}/reports/get_pipeline_invoice/`,
        {
            headers: { Authorization: `Bearer ${token}` },
        }
        );
        setOptions(response.data.pipeline_invoice || []);
       
        const d = response.data;
        if (response.status === 200) {
            setData({
            ...d,
            });
        }
    } catch (error) {
        console.error("API Error:", error);
    } finally {
        setGlobalLoading(false); 
    }
  }

  useEffect(() => {
    if (token) {
        fetchOptions();
    }
  }, [token]); 

  const accountManagers = useMemo(() => {
    return [...new Set(
      options
        .map((item) => item.account_manager)
        .filter(Boolean)
    )].sort();
  }, [options]);  

  const filteredOptions = useMemo(() => {
    if (!selectedManager) return options;

    return options.filter(
      (item) => item.account_manager === selectedManager
    );
  }, [options, selectedManager]);

  
  const totalAmountInINR = useMemo(() => {
    return filteredOptions.reduce((sum, row) => {
      return sum + (Number(row.amount) || 0);
    }, 0);
  }, [filteredOptions]);

    return (
        <>
        <style>
        {`
        .table {
            font-size: 12px;
            margin-bottom: 0;
          }
          .table th,
          .table td {
            padding: 4px 8px !important;
            white-space: nowrap;
            vertical-align: middle;
            line-height: 1.2;
          }
          .table-responsive {
            overflow: auto;
            max-height: 700px;
          }
          /* Header */
          thead th {
            position: sticky;
            top: 0;
            background: #f5f5f5 !important;
            z-index: 20;
            font-weight: 600;
          }
          /* 1st column - Unit Head */
          .sticky-col-1 {
            position: sticky;
            left: 0;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 2nd column - Generated / Net Add */
          .sticky-col-2 {
            position: sticky;
            left: 100px;
            background: #fff;
            z-index: 15;
            min-width: 100px;
          }
          /* 3rd column - Revenue Total */
          .sticky-col-3 {
            position: sticky;
            left: 200px;
            background: #fff;
            z-index: 15;
            min-width: 140px;
          }
          /* Sticky header + sticky columns */
          thead .sticky-col-1,
          thead .sticky-col-2,
          thead .sticky-col-3 {
            background: #f5f5f5 !important;
            z-index: 25;
          }
          /* Optional border */
          .sticky-col-1,
          .sticky-col-2,
          .sticky-col-3 {
            box-shadow: 1px 0 0 #ddd;
          }
        .chart-box {
              min-height: 250px; /* adjust as needed */
              display: flex;
              flex-direction: column;
          } 
        .client-column {
            width: 70%;
            white-space: normal !important;
            word-break: break-word;
            }

        .amount-column {
            width: 30%;
            white-space: nowrap;
            } 
        .sticky-summary td {
            position: sticky;
            top: 22px;      /* Height of the header */
            background: #e9ecef;
            z-index: 20;
            font-weight: bold;
        }      
        `}
        </style>  
  
        <div className="card shadow-sm mb-4">
        <div className="card-body">
            <div className="card-header pb-2 d-flex align-items-center justify-content-between flex-wrap">
                <h5 className="mb-0">
                    Pipeline Invoices
                </h5>
                <div className="d-flex justify-content-end mb-2">
                    <div className="fw-bold fs-15">
                        Total INR: <span className="text-success">₹ {formatNumber(totalAmountInINR)}</span>
                    </div>
                </div>
                <div style={{ width: "250px" }}>
                  <select
                    className="form-select form-select-sm"
                    value={selectedManager}
                    onChange={(e) => setSelectedManager(e.target.value)}
                  >
                    <option value="">All Account Managers</option>

                    {accountManagers.map((manager) => (
                      <option key={manager} value={manager}>
                        {manager}
                      </option>
                    ))}
                  </select>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 col-xl-12 col-xxl-12">
                    <div className="table-responsive" style={{ maxHeight: "800px" }}>
                    <table className="table table-bordered table-hover">
                        <thead className="table-dark">
                            <tr>
                                <th className="sticky-col-1">Client</th>
                                <th className="sticky-col-2">Role</th>
                                <th className="sticky-col-3">Retainer/Candidate</th>
                                <th>Account Manager</th>
                                <th>Raised Date</th>
                                <th className="text-end">Entity</th>
                                <th className="text-end">Amount</th>
                                <th className="text-end">Status</th>
                            </tr>
                        </thead>
                        {/* Company Rows */}
                        <tbody>    
                            {filteredOptions.map((row, index) => (
                                <tr key={index}>
                                    <td>
                                      <a href={`/client/view/${row.company_id}`} onClick={(e) => { e.preventDefault(); openInAppTab(`/client/view/${row.company_id}`); }} target="_blank" rel="noreferrer" title={decodeHtml(row.company_name)}>
                                        {row.company_name.length > 30 ? `${row.company_name.substring(0, 30)}...` : decodeHtml(row.company_name)}
                                      </a>
                                    </td>
                                    <td>
                                      <a href={`/role/view/${row.role_id}`} target="_blank" rel="noreferrer" title={decodeHtml(row.role_name)} onClick={(event) => {
                                        event.preventDefault();
                                        openInAppTab(
                                          `/role/view/${row.role_id}`,
                                        );
                                      }}>
                                        {row.role_name.length > 35 ? `${row.role_name.substring(0, 35)}...` : decodeHtml(row.role_name)}
                                      </a>
                                    </td>
                                    <td>{row.candidate_name ? row.candidate_name : row.retainer}</td>
                                    <td>{row.account_manager}</td>
                                    <td>{row.raised_date}</td>
                                    <td>{row.entity_name}</td>
                                    <td className="text-end">{formatNumber(row.amount)}</td>
                                    <td>{row.role_status}</td>
                                </tr>
                            ))}

                        </tbody>    
                    </table>
                    </div> 
                </div>
            </div>

        </div>
        </div>

        </>
    );
}

export default InvoicePipeline;
